import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { trackEvent, setAnalyticsConsent } from '../utils/analytics';

const CookieConsent = ({ onAccept, onDecline, onLearnMore }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('morse_cookie_consent');
        if (!consent) {
            // Small delay to not jar the user immediately
            const timer = setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('morse_cookie_consent', 'accepted');
        setVisible(false);
        setAnalyticsConsent(true);
        if (onAccept) onAccept();
        trackEvent('cookie_consent', { status: 'accepted' });
    };

    const handleDecline = () => {
        localStorage.setItem('morse_cookie_consent', 'declined');
        setVisible(false);
        setAnalyticsConsent(false);
        if (onDecline) onDecline();
        // Track the decision before opting out (if possible)
        trackEvent('cookie_consent', { status: 'declined' });
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 animate-in slide-in-from-bottom duration-500">
            <div className="bg-surface border border-primary/20 shadow-2xl rounded-2xl p-5 relative overflow-hidden">
                {/* Background decoration */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary/0 via-primary to-primary/0 opacity-50" />

                <div className="flex items-start gap-3">
                    <div className="bg-primary/10 p-2 rounded-full shrink-0">
                        <Cookie className="text-primary" size={20} />
                    </div>
                    <div className="space-y-2">
                        <h3 className="font-bold text-main text-sm">We value your privacy</h3>
                        <p className="text-xs text-muted leading-relaxed">
                            We use cookies to enhance your experience, track your progress, and analyze usage.
                            We do not sell your data.
                        </p>
                    </div>
                </div>

                <div className="mt-4 flex gap-2">
                    <button
                        onClick={handleDecline}
                        className="flex-1 px-3 py-2 rounded-lg text-xs font-bold text-muted hover:bg-base hover:text-main transition-colors border border-border"
                    >
                        Decline
                    </button>
                    <button
                        onClick={handleAccept}
                        className="flex-1 px-3 py-2 rounded-lg text-xs font-bold bg-primary text-primary-content hover:bg-primary-hover shadow-lg shadow-primary/20 transition-all active:scale-95"
                    >
                        Accept
                    </button>
                </div>

                <div className="mt-2 text-center">
                    <button onClick={onLearnMore} className="text-[10px] text-primary/70 hover:text-primary underline">
                        Read Privacy Policy
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
